import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useError } from '../../../field-error';
import { useFieldAttributes } from '../../../services/field-attributes';
import { DateTimeFieldWUT } from '../../../ui/date-time-field/date-time-field-wut';
import { getDateTimeFieldError, getDateTimePartsErrors, getDateTimeValidationErrorSuffix } from '../../../ui/date-time-field/date-time-field-utils';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
import { FieldLabelWUT } from '../../../ui/field-label/field-label-wut';
export const DateTimeInputWUT = _ref => {
  let {
    id,
    description,
    validation,
    target,
    value,
    error,
    required,
    label,
    hideLabel,
    FieldLayout,
    use24HourFormat,
    disabled,
    hidePlaceholder,
    showDateLabels,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    onBlur,
    onFocus,
    onChange
  } = _ref;
  const dateTimeFieldError = getDateTimeFieldError(validation, error, value ?? '');
  const {
    errorMessage,
    hasError
  } = useError(dateTimeFieldError, undefined, FIELD_TYPES.DATE_TIME_INPUT, getDateTimeValidationErrorSuffix(dateTimeFieldError));
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(DateTimeFieldWUT, {
      use24HourFormat: use24HourFormat,
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus,
      value: value ?? '',
      id: id,
      disabled: disabled,
      hidePlaceholder: hidePlaceholder,
      showDateLabels: showDateLabels,
      required: required,
      errors: getDateTimePartsErrors(hasError, value ?? ''),
      inputId: inputId,
      ariaLabelledBy: labelId,
      ariaDescribedBy: ariaDescribedBy
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=date-time-input-wut.js.map